var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-branch.fe5615db.png","uri@2x": __webpack_public_path__ + "icon-branch.c71befb6.png","uri@3x": __webpack_public_path__ + "icon-branch.23379f22.png",
    width: 14,
    height: 18
});